(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices/player-exclusions/assets/javascripts/data/definitions.js') >= 0) return;  svs.modules.push('/components/accountservices/player-exclusions/assets/javascripts/data/definitions.js'); 'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var subSystems = ['alla', 'bingo', 'casino', 'poker', 'sport'];
var pauseTypes = {
  GamingPause24: 1,
  PauseSixMonths: 2,
  PauseThirtySixMonths: 3,
  PauseThreeMonths: 4,
  PauseTwelveMonths: 5,
  PauseTwelveMonthsGcs: 6,
  PauseTwentyFourHours: 7,
  PauseTwentyFourHoursGcs: 8
};
var verticals = {
  ALLA: 'Alla spel',
  BINGO: 'Bingo',
  CASINO: 'Casino',
  POKER: 'Poker',
  SPORT: 'Sportspel'
};
var gcsProducts = {
  alla: 'All',
  bingo: 'Bingo',
  casino: 'NetCasino',
  poker: 'Poker',
  sport: 'SportsBetting'
};
var gcsLevel = {
  STEP2: 'LevelTwo',
  STEP4: 'LevelFour'
};
var definitions = {
  gcsLevel: gcsLevel,
  gcsProducts: gcsProducts,
  pauseTypes: pauseTypes,
  subSystems: subSystems,
  verticals: verticals
};

if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
  module.exports = {
    definitions: definitions
  };
} else {
  svs.accountservices.player_exclusions.definitions = definitions;
}
 })(window);